/* React base class */
import { Component } from "react"

/* Redux store connection */
import { connect } from "react-redux"

/* Router HOC */
import { withRouter } from "../helpers"

/* Icon component */
import Icon from "../components/Icon"

/* Translation */
import { translate } from "../translates"

/* Widget Footer */
class Footer extends Component {

    /* Draw Go */
    _go = (event, route) => {

        /* Fields */
        const { navigate } = this.props

        event.preventDefault()
        navigate(route)
    }

    /* Draw Go Auth */
    _goAuth = (event, route) => {

        /* Fields */
        const { user, navigate, toggleAuth } = this.props

        event.preventDefault()

        if (user) {
            navigate(route)
        }
        else {
            toggleAuth(true)
        }
    }

    /* Draw Brand */
    _brand = () => {
        return (
            <div>
                <img className="footer__logo" src="/logo-white.png" alt="Bookify" />
                <p className="footer__tag">{translate("Бронируйте услуги в лучших организациях Казахстана за пару кликов.")}</p>
                <ul className="footer__contacts">
                    <li><Icon name="phone" size={15} /><span><a href="tel:+77071385100">+7 (707) 138-51-00</a></span></li>
                    <li><Icon name="mail" size={15} /><a href="mailto:info@bookify.kz">info@bookify.kz</a></li>
                    <li><Icon name="pin" size={15} /><span>{translate("Микрорайон Мамыр 1, 26, БЦ Quorum, 508 кабинет, Алматы")}</span></li>
                </ul>
            </div>
        )
    }

    /* Draw Clients */
    _clients = () => {
        return (
            <div>
                <h4>{translate("Для клиентов")}</h4>
                <ul>
                    <li><a href="#" onClick={(event) => this._go(event, "/search")}>{translate("Поиск организаций")}</a></li>
                    <li><a href="#" onClick={(event) => this._goAuth(event, "/bookings")}>{translate("Мои записи")}</a></li>
                    <li><a href="#" onClick={(event) => this._goAuth(event, "/favourites")}>{translate("Избранное")}</a></li>
                    <li><a href="#" onClick={(event) => this._goAuth(event, "/gifts")}>{translate("Подарочные сертификаты")}</a></li>
                    <li><a href="https://i.bookify.kz/install" target="_blank" rel="noreferrer">{translate("Скачать приложение")}</a></li>
                </ul>
            </div>
        )
    }

    /* Draw Business */
    _business = () => {
        return (
            <div>
                <h4>{translate("Для бизнеса")}</h4>
                <ul>
                    <li><a href="/partnership" target="_blank" rel="noreferrer">{translate("Подключить организацию")}</a></li>
                    <li><a href="/partnership#pricing" target="_blank" rel="noreferrer">{translate("Тарифы")}</a></li>
                    <li><a href="/partnership#features" target="_blank" rel="noreferrer">{translate("CRM для мастеров")}</a></li>
                    <li><a href="/partnership#contacts" target="_blank" rel="noreferrer">{translate("Партнёрская программа")}</a></li>
                </ul>
            </div>
        )
    }

    /* Draw Help */
    _help = () => {
        return (
            <div>
                <h4>{translate("Помощь")}</h4>
                <ul>
                    <li><a href="#" onClick={(event) => this._go(event, "/about")}>{translate("О компании")}</a></li>
                    <li><a href="#" onClick={(event) => this._go(event, "/help")}>{translate("Поддержка")}</a></li>
                    <li><a href="#" onClick={(event) => this._go(event, "/contacts")}>{translate("Контакты")}</a></li>
                    <li><a href="#" onClick={(event) => this._go(event, "/public-offer")}>{translate("Публичная оферта")}</a></li>
                    <li><a href="#" onClick={(event) => this._go(event, "/privacy-policy")}>{translate("Политика конфиденциальности")}</a></li>
                </ul>
            </div>
        )
    }

    render = () => {
        return (
            <footer className="footer">
                <div className="container">
                    <div className="footer__grid">
                        {this._brand()}
                        {this._clients()}
                        {this._business()}
                        {this._help()}
                    </div>
                    <div className="footer__bottom">
                        <span>© 2026 Bookify Kazakhstan · ТОО «SARY GROUP» · БИН 240440023071</span>
                        <span>info@bookify.kz · +7 (707) 138-51-00</span>
                    </div>
                </div>
            </footer>
        )
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        user: state.user,
        lang: state.lang
    }
}

/* Map Dispatch To Props */
const mapDispatchToProps = dispatch => {
    return {
        toggleAuth: data => dispatch({ type: "TOGGLE_AUTH", payload: data })
    }
}

/* Export */
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Footer))
